import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { VistaAdminUsuarioComponent } from "./vista-admin-usuario/vista-admin-usuario.component";
import { BuscarUsuarioComponent } from "./vista-admin-usuario/buscar-usuario/buscar-usuario.component";
import { FormularioUsuarioComponent } from "./vista-admin-usuario/formulario-usuario/formulario-usuario.component";
import { ListaErroresComponent } from "./vista-admin-usuario/lista-errores/lista-errores.component";
import { CargaMasivaComponent } from "./vista-admin-usuario/carga-masiva/carga-masiva.component";
import { EncuestaComponent } from "./vista-admin-usuario/encuesta/encuesta.component";
import { ListaEnviadosComponent } from "./vista-admin-usuario/lista-enviados/lista-enviados.component";


import { AuthServiceConfig, SocialLoginModule} from "angularx-social-login";
import { LoginComponent } from "./login/login.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";

import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatListModule } from "@angular/material/list";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FileUploadModule } from "ng2-file-upload";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from '@angular/material/tabs';
import { NgApexchartsModule } from "ng-apexcharts";

import { AutorizacionService } from "./autorizacion.service";
import { HomeComponent } from "./home/home.component";
import { Globals } from "./globals";
import { AdministradorConflictosComponent } from "./administrador-conflictos/administrador-conflictos.component";
import { NuevoConflictoComponent } from "./administrador-conflictos/nuevo-conflicto/nuevo-conflicto.component";
import { ActualizarConflictoComponent } from "./administrador-conflictos/actualizar-conflicto/actualizar-conflicto.component";
import { PreguntaComponent } from "./administrador-conflictos/pregunta/pregunta.component";
import { FormularioConflictoComponent } from "./administrador-conflictos/pregunta/formulario-conflicto/formulario-conflicto.component";
import { EntradaTipoSeleccionComponent } from "./administrador-conflictos/pregunta/formulario-conflicto/entrada-tipo-seleccion/entrada-tipo-seleccion.component";
import { EntradaComponent } from "./administrador-conflictos/pregunta/formulario-conflicto/entrada/entrada.component";
import { EntradaAreaComponent } from "./administrador-conflictos/pregunta/formulario-conflicto/entrada-area/entrada-area.component";
import { EntradaFechaComponent } from "./administrador-conflictos/pregunta/formulario-conflicto/entrada-fecha/entrada-fecha.component";
import { MatNativeDateModule, MatRadioButton } from "@angular/material";
import { MatRadioModule } from "@angular/material";
import { EntradaNumeroComponent } from "./administrador-conflictos/pregunta/formulario-conflicto/entrada-numero/entrada-numero.component";
import { EntradaSeleccionAbiertaComponent } from "./administrador-conflictos/pregunta/formulario-conflicto/entrada-seleccion-abierta/entrada-seleccion-abierta.component";
import { CierreConflictoComponent } from "./administrador-conflictos/actualizar-conflicto/cierre-conflicto/cierre-conflicto.component";
import { AdministradorPreguntasComponent } from './administrador-preguntas/administrador-preguntas.component';
import { ActualizadorPreguntasComponent } from './administrador-preguntas/actualizador-preguntas/actualizador-preguntas.component';
import { PreguntasFrontComponent } from './administrador-preguntas/preguntas-front/preguntas-front.component';
import { OkFrontPreguntasComponent } from './administrador-preguntas/ok-front-preguntas.component';
import { NewhomeComponent } from './newhome/newhome.component';
import { ResumenConflictosComponent } from './administrador-preguntas/resumen-conflictos/resumen-conflictos.component';
import { ResumenEncuestaComponent } from './vista-admin-usuario/resumen-encuesta/resumen-encuesta.component';
import { ListaPreguntasComponent } from "./vista-admin-usuario/lista-preguntas/lista-preguntas.component";
import { SelectAnnioComponent } from './vista-admin-usuario/select-annio/select-annio.component';
import { ReporteEstadisticoComponent } from './reportes/reporte-estadistico/reporte-estadistico.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';


const config = new AuthServiceConfig([
  // {
  //   id: GoogleLoginProvider.PROVIDER_ID,
  //   // provider: new GoogleLoginProvider("624796833023-clhjgupm0pu6vgga7k5i5bsfp6qp6egh.apps.googleusercontent.com")
  //   //"581597265800-fkoldqutoq0bl337fageju6eepo5cvv3.apps.googleusercontent.com" local
  //   //"444148384562-bp1kft336uih6e0gga3t4njabg50q3i8.apps.googleusercontent.com" prod
  //   //"855390242542-uc86trrvlchos6r038cj87sa3h0r2m8k.apps.googleusercontent.com" PROD Final
  //   provider: new GoogleLoginProvider(
  //     "855390242542-uc86trrvlchos6r038cj87sa3h0r2m8k.apps.googleusercontent.com"
  //   )
  // }


]);




export function provideConfig() {
  return config;
}

// export function MSALInstaceFactory():IPublicClientApplication{
//   return new PublicClientApplication({
//     auth:{
//       clientId: "2637d50c-c560-436c-8997-ebe63c9656fd",
//       redirectUri: "https://compliance.fronteraenergy.ca/auth/redirect"

//     }
//   })
// }


const firebaseConfig = {
  apiKey: "AIzaSyBtFd2CyG9Ftb9sU3FqNCwTvu6fqTccIZM",
  authDomain: "frontera-habilitantes-dev.firebaseapp.com",
  databaseURL: "https://frontera-habilitantes-dev.firebaseio.com",
  projectId: "frontera-habilitantes-dev",
  storageBucket: "frontera-habilitantes-dev.appspot.com",
  messagingSenderId: "444148384562",
  appId: "1:444148384562:web:0b41bb6f3190decd78cd2b"
};

@NgModule({
  declarations: [
    AppComponent,
    VistaAdminUsuarioComponent,
    BuscarUsuarioComponent,
    FormularioUsuarioComponent,
    ListaErroresComponent,
    CargaMasivaComponent,
    LoginComponent,
    HomeComponent,
    EncuestaComponent,
    ListaEnviadosComponent,
    AdministradorConflictosComponent,
    NuevoConflictoComponent,
    ActualizarConflictoComponent,
    PreguntaComponent,
    FormularioConflictoComponent,
    EntradaTipoSeleccionComponent,
    EntradaComponent,
    EntradaAreaComponent,
    EntradaFechaComponent,
    EntradaNumeroComponent,
    EntradaSeleccionAbiertaComponent,
    CierreConflictoComponent,
    AdministradorPreguntasComponent,
    ActualizadorPreguntasComponent,
    PreguntasFrontComponent,
    OkFrontPreguntasComponent,
    NewhomeComponent,
    ResumenConflictosComponent,
    ResumenEncuestaComponent,
    ListaPreguntasComponent,
    SelectAnnioComponent,
    ReporteEstadisticoComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SocialLoginModule,
    BrowserAnimationsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatGridListModule,
    MatToolbarModule,
    MatTableModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatProgressBarModule,
    MatListModule,
    FileUploadModule,
    FontAwesomeModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatIconModule,
    MatTabsModule,
    NgApexchartsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule
  ],

  providers: [
    AutorizacionService,
    Globals,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    },

  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
